import {PWMAT_RESOURCE} from './consts'

export const ReadPaper = [
  {
    name: '1. La and Mn doped cobalt spinel oxygen evolution catalysts for proton exchange membrane electrolysis [Science]',
    url: 'https://mp.weixin.qq.com/s/OuaAYEkerhxGeVOqxdBcIQ',
  },
  {
    name: '2. Photoinduced phase transition mechanism of In lines on silicon [PRL]',
    url: 'https://mp.weixin.qq.com/s/0sEBloUVuBSrTpWZMVZIcw',
  },
  {
    name: '3. Algorithmic progress of real-time time-dependent density functional theory (rt-TDDFT) and its application in ultrafast dynamics [Wires Comput Mol Sci]',
    url: 'https://mp.weixin.qq.com/s/z1dueYPewceGSuaIEDe1Cg',
  },
  {
    name: '4. Combining theory and experiment to study the photostrictive effect of functional ceramics [Matter]',
    url: 'https://mp.weixin.qq.com/s/n1JSDZ37Z2gLbJAzRoj1Hg',
  },
  {
    name: '5. Science China Technological Sciences: Computation of electroacoustic coupling matrix - theoretical introduction, code development and preliminary application [Sci. China Technol. Sci]',
    url: 'https://mp.weixin.qq.com/s/O29YwGkc-L6TkPoLuuVDDQ',
  },
  {
    name: '6. Simulation of Lithium Dendrite Morphology Evolution in Electrolyte Environment [Advanced Energy Materials]',
    url: 'https://mp.weixin.qq.com/s/kapzIrPvL2AcGTUzdHgglg',
  },
  {
    name: '7. Combining experiments and calculations to study a new type of two-dimensional semiconductor/ferroelectric multi-value memory based on vertical architecture [Advanced Materials]',
    url: 'https://mp.weixin.qq.com/s/5Yx7DkwHJ3u9EU65Zqg1FA',
  },
  {
    name: '8. Combining experimental and theoretical calculations to study the twin nucleation and propagation process in Pb nanocrystals [Science Advances]',
    url: 'https://mp.weixin.qq.com/s/puL7Qgi_4Hcou_eYtk8NCQ',
  },
  {
    name: '9. Accurate calculation of ion dissolution free energy based on mixed solvent model in PWmat [JCTC]',
    url: 'https://mp.weixin.qq.com/s/RalNE_Yu3Q8iKohS1bm1dw',
  },
  {
    name: '10. Potential-driven semiconductor-metal phase transition in 2D transition metal dichalcogenides [Advanced Functional Materials]',
    url: 'https://mp.weixin.qq.com/s/hxLKDAJ0XFiABps2Lt2ngg',
  },
{
  name: '11. Acidic OER Mechanism Exploration: Operando Direct Observation of Stable Intermediates on Ca2-xIrO4 [Nano Lett.]',
  url: 'https://mp.weixin.qq.com/s/q_NT2cDp9OhKR5UWPqYwlg',
},
{
  name: '12. First-principles calculations of fluorine-terminated diamond surfaces for NV color centers [Carbon]',
  url: 'https://mp.weixin.qq.com/s/fzuDc-IkQwCiceIVMZ1FzA',
},
{
  name: '13. Unifying the order and disorder dynamics during the light-induced phase transition of vanadium dioxide [PNAS]',
  url: 'https://mp.weixin.qq.com/s/D85ZWf19QPlQCmlXfnKdxw',
},
{
  name: '14. Study on the mechanism of non-thermal melting during laser-induced annealing of semiconductor materials [Science Advances]',
  url: 'https://mp.weixin.qq.com/s/2K6oOkWv7sEjo0i8zUSelw',
},
{
  name: '15. Correction of image charge interactions in charged defect calculations [Physical Review B]',
  url: 'https://mp.weixin.qq.com/s/n2dH-lwj2-YhMDnvuou0iA',
},
{
  name: '16. TDDFT reveals the mechanism of electron-induced semiconductor/oxide interface defect generation[PRB]',
  url: 'https://mp.weixin.qq.com/s/5F623D5tgHdewio-GtyFrA',
},
{
  name: '17. Breaking the linear relationship in MXenes electrocatalytic CO2 reduction to achieve efficient CH4 production [CEJ]',
  url: 'https://mp.weixin.qq.com/s/kGGuTX40Z3nVYfkX956RpA',
},
{
  name: '18. Application of PtS2/GaSe van der Waals heterojunction in solar energy conversion [PCCP]',
  url: 'https://mp.weixin.qq.com/s/SdizcsMTMdpM5zU6n1Bjfg',
},
{
  name: '19. Defect modulation Jahn-Teller effect in layered LiNiO₂[Science China Materials]',
  url: 'https://mp.weixin.qq.com/s/CQtQe9qnDQWt_vxVZTEXog',
},
{
  name: '20. Photocatalytic synergistic degradation of tetracycline by ultrathin h-BN/Bi2MoO6 heterostructures [Journal of Colloid and Interface Science]',
  url: 'https://mp.weixin.qq.com/s/...',
},
// Continue from the previous entries...
{
  name: '21. DFT study of non-radiative recombination processes in II-VI group ionic semiconductors [Physical Review Applied]',
  url: 'https://mp.weixin.qq.com/s/MwibV1OrqHRtvWs64bk_tw',
},
{
  name: '22. PWmat has achieved important results in calculating the quantum effects of semiconductor point defects [ADVANCE OPTICAL MATERIALS]',
  url: 'https://mp.weixin.qq.com/s/jIJUeo9TBCLEGmSmraru7w',
},
{
  name: '23. Fixed-potential method to study the effect of electrode potential on single-atom catalyst OER reaction [Journal of Catalysis]',
  url: 'https://mp.weixin.qq.com/s/Y7Ga776KQbzzL8VqbCqMXA',
},
{
  name: '24. Three-dimensional moiré fringe superlattice structure under helical twist [PRB]',
  url: 'https://mp.weixin.qq.com/s/oxHogZMv_FJl_OKMb4V-yA',
},
{
  name: '25. Single-photon emission sources based on point defects in III-nitride materials [ACS Applied Materials & Interfaces]',
  url: 'https://mp.weixin.qq.com/s/ebFmVhfRFvGXyqp1bH7NVw',
},
{
  name: '26. Carbon-doped hexagonal boron nitride nanoribbons as efficient metal-free electrochemical catalyst for ammonia synthesis [Chemical Engineering Journal]',
  url: 'https://mp.weixin.qq.com/s/8S67hrIGHarQxzSHXQOpiQ',
},
{
  name: '27. TDDFT study of ultrafast structural phase transitions regulated by light field: the important role of hot carrier cooling [npj Computational Materials]',
  url: 'https://mp.weixin.qq.com/s/oJ_0CRbV34By4Mz_zi-1zA',
},
{
  name: '28. PWmat’s solvent model module for Li-S battery results [Advance Energy Materials]',
  url: 'https://mp.weixin.qq.com/s/gAlAGkS4X9OcBAw6a_fn4w',
},
{
  name: '29. CPM study of switchable asymmetric moiré fringes with strong localized states[J. Phys. Chem. Lett.]',
  url: 'https://mp.weixin.qq.com/s/owt7CzyBokqGe23zio1tVA',
},
{
  name: '30. Combining experiments and theories to study the structural origin of lithium cobalt oxide instability under high pressure [Nature Nanotechnology]',
  url: 'https://mp.weixin.qq.com/s/oB166VSTg3n2imz8hPP70g',
},
// Continue from the previous entries...
{
  name: '31. Multiscale simulation of phonon-assisted hopping between defect states in MoS2[J. Phys. Chem. Lett.]',
  url: 'https://mp.weixin.qq.com/s/eepRLYErQEyOhMcIeCr2RQ',
},
{
  name: '32. Effect of manganese doping on the electron injection process in quantum dot-sensitized solar cells [PCCP]',
  url: 'https://mp.weixin.qq.com/s/eOTjwB6ilVWj7EKcD6_t0Q',
},
{
  name: '33. PWmat published important results on HSE method for heterojunction electronic structure calculation [PCCP]',
  url: 'https://mp.weixin.qq.com/s/htADAD1FAxBAFPDiOy6Gfg',
},
{
  name: '34. PWmat\'s TDDFT module published important research results [PCCP]',
  url: 'https://mp.weixin.qq.com/s/fFo-At42ci9aGB-cGmIxKw',
},
{
  name: `35. Non-harmonic approximation of Marcus charge transfer theory reveals defect-induced
  charge trapping/de-trapping and hysteresis in MoS₂ field-effect transistors [ACS Applied Materials & Interfaces]`,
  url: 'https://mp.weixin.qq.com/s/3X6FPjmS78AqxbdiGuyqOg',
},
{
  name: '36. Unveiling the charge dynamics in an acetylene-bridged Donor-π-Acceptor covalent triazine framework for enhanced photoredox catalysis [ACS Catal]',
  url: 'https://mp.weixin.qq.com/s/BKSm_I3ZXknIcWMP0v0bVA',
},
{
  name: '37. Molecular dynamics simulation reveals the electron beam irradiation damage mechanism of hybrid perovskite materials [Appl. Phys. Lett]',
  url: 'https://mp.weixin.qq.com/s/ix-kYeYrfwgf_h2SN3Pxpw',
},
{
  name: '38. Dynamics of electron excitation induced by impurity diffusion in semiconductors [Physical Review B]',
  url: 'https://mp.weixin.qq.com/s/XGlpe6zG8dmD_rebllli8g',
},
{
  name: '39. Floquet electronic structure induced by electroacoustic coupling [npj Quantum Mater]',
  url: 'https://mp.weixin.qq.com/s/JIACH-ZGtyYtYGv1yD2BbQ',
},
{
  name: '40. Oxygen reduction reaction catalyzed by single iron atom on defective graphene surface[J. Phys. Chem]',
  url: 'https://mp.weixin.qq.com/s/tL7xdQRh3CzrVnLX-HTDaw',
},
{
  name: `41. Design of solid-state three-dimensional lithium-sulfur battery by stacking two-dimensional
  conductive microporous coordination polymer and amorphous Li-S layers [Chemistry of Materials]`,
  url: 'https://mp.weixin.qq.com/s/RL0euSvwgs2JUGZmPidt5A',
},
{
  name: '42. Multi-scale simulation of lateral charge loss in Si3N4 3D NAND flash memory[J. Phys. D]',
  url: 'https://mp.weixin.qq.com/s/2Ql5h_bbU7OeXxhJaLMefw',
},
{
  name: '43. Combining experiments with theoretical calculations has made important progress in the study of nitride semiconductor doping [PRL]',
  url: 'https://mp.weixin.qq.com/s/KX1eDo1j9SRudIcFEMQtIw',
},
{
  name: '44. Revealing the working mechanism of multifunctional block copolymer binder in lithium-sulfur battery [Journal of Energy Chemistry]',
  url: 'https://mp.weixin.qq.com/s/GdOqjQxk3Cfgz_jfrUjdmQ',
},
{
  name: `45. Combining experiments and theoretical calculations to study the effects of defect types
  and defect concentration in copper metal surface passivation films [Journal of Electroanalytical Chemistry]`,
  url: 'https://mp.weixin.qq.com/s/NMn6UjLqWgoqVK0T133nIg',
},
{
  name: '46. Combining experiments with theoretical calculations to achieve progress in the research of high-performance sodium-ion battery anode materials [Nano Energy]',
  url: 'https://mp.weixin.qq.com/s/8K8ta3gVDgTmHHkb5UA0ZA',
},

]


